import { publicRoutes } from './publicRoutes'
import { hybridRoutes } from './hybridRoutes'
import { privateRoutes } from './privateRoutes'

const routes = [
  ...publicRoutes,
  ...hybridRoutes,
  ...privateRoutes,
  {
    path: '*',
    redirect: '/'
  }
]

export default routes
